import { render, staticRenderFns } from "./LodomelixCollection.vue?vue&type=template&id=73304068"
import script from "./LodomelixCollection.vue?vue&type=script&lang=js"
export * from "./LodomelixCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports